<script setup lang="ts">
import type { IntroMode } from '../../lib/experience'
import { primaryLogoUrl } from '../../lib/brand'

defineProps<{
  mode: IntroMode
  complete: boolean
}>()

defineEmits<{
  skip: []
}>()
</script>

<template>
  <Transition name="boot">
    <div v-if="!complete" class="boot-sequence" :class="`boot-sequence--${mode}`">
      <div class="boot-sequence__grid" aria-hidden="true" />
      <p class="boot-sequence__status">
        <span class="status-dot" />
        SYSTEM WAKE / SE-2026
      </p>
      <div class="boot-sequence__core">
        <span class="boot-sequence__scanner" aria-hidden="true" />
        <img :src="primaryLogoUrl" alt="SE 2026 标志" width="164" height="164" />
        <span class="boot-sequence__ring" aria-hidden="true" />
      </div>
      <div class="boot-sequence__copy" aria-live="polite">
        <span>INITIALIZING SE UNIVERSE</span>
        <strong>欢迎进入软件工程</strong>
      </div>
      <div class="boot-sequence__meter" aria-hidden="true"><span /></div>
      <button class="boot-sequence__skip" type="button" @click="$emit('skip')">
        跳过动画
        <span aria-hidden="true">↗</span>
      </button>
    </div>
  </Transition>
</template>
